import { useEffect, useCallback } from 'react';

export interface AppEventMap {
  "publishEvent": { 
    isPublishProccess: boolean 
  };
  "mobileViewReady": {
    iframeDocument: Document | null
  };
}

export type AppEventName = keyof AppEventMap;

export const 
useCustomEvents = () => {
  const emit = useCallback(<K extends AppEventName>(
    eventName: K, 
    detail: AppEventMap[K]
  ) => {
    const event = new CustomEvent(eventName, { detail });
    window.dispatchEvent(event);
  }, []);

  const useSubscribe = <K extends AppEventName>(
    eventName: K, 
    handler: (detail: AppEventMap[K]) => void
  ) => {
    useEffect(() => {
      const wrapper = (e: Event) => {
        const customEvent = e as CustomEvent<AppEventMap[K]>;
        handler(customEvent.detail);
      };

      window.addEventListener(eventName, wrapper);
      return () => window.removeEventListener(eventName, wrapper);
    }, [eventName, handler]);
  };

  return { emit, useSubscribe };
};